import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {FieldsJs} from "../../../../settings/General/General";
import TextField from "@material-ui/core/TextField";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {Send} from "@material-ui/icons";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import icon_email from "../../../../assets/img/icons/email.svg";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import {FacturacionService} from "../../../../services/FacturacionService/FacturacionService";
import {CONFIG} from "../../../../settings/Config/Config";

class ModalPrevisualizarTimbrado extends Component {
	
	state = {};
	
	Usr = ReactLocalStorageService.get('Usr') || {};
	
	showSnackBars = this.props.showSnackBars;
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			open: this.props.open,
			scroll: 'paper',
			
			tipo: props.tipo,
			item: props.item,
			id_facturacion: (props.item || {}).id_facturacion,
			id_facturacion_archivo: (props.item || {}).id_facturacion_archivo,
			id_usuario_email: '',
			check_email: true,
			check_rocket_chat: false,
			text_email: '',
			solicitante: '',
			correo_electronico: '',
			correo_electronico_copia: '',
			text_email_solicitante: '',
			otro_usuario: false,
			
		};
	}
	
	
	openModal = () => {
		const {item} = this.props;
		console.log("ITEM:::", item);
		
		this.setState({
			open: true,
			scroll: 'paper',
			item: item,
			id_usuario_email: '',
			correo_electronico: '',
			correo_electronico_copia: '',
			check_email: true,
			check_rocket_chat: false,
			otro_usuario: false,
			text_email: '',
			text_email_solicitante: '',
			id_facturacion: item.id_facturacion || '',
			id_facturacion_archivo: item.id_facturacion_archivo || '',
		});
	};
	
	closeModal = () => {
		this.setState({open: false});
	};
	
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	is_add = () => {
		return this.props.tipo === 'add';
	};
	
	is_root = () => {
		return FieldsJs.inArray([1], this.Usr.id_cat_tipo_usuario);
	};
	
	is_view = () => {
		return this.props.tipo === 'view';
	};
	
	is_edit = () => {
		return this.props.tipo === 'edit';
	};
	
	close = () => {
		this.closeModal();
	};
	
	save = () => {
		FacturacionService.SendMail(this.state).then((response) => {
			this.close();
			this.showSnackBars('success', response.mensaje);
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	saveSolicitante = () => {
		/*TicketsService.SendMail(this.state, true).then((response) => {
			this.close();
			this.showSnackBars('success', response.mensaje);
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});*/
	};
	
	exportar = (link) => {
		let url = CONFIG.src_facturacion+link;
		window.open(url, '', 'width=900, height=600');
	};
	
	render() {
		
		return (
			<span>
				
				{/*{this.props.component ? (
					<Fragment>
						<span style={{cursor: 'pointer'}}>
							{this.props.component}
						</span>
					</Fragment>
				) : (
					<Fragment>
						<Fab variant="extended" size="small" color="primary" aria-label="Add"
						     className={'margin-10-L'} onClick={() => this.openModal('paper')}>
							<Send className={'margin-5-R px-14'}/>
							Descargar Archivos
						</Fab>
					</Fragment>
				)}*/}
				
				<Dialog disableBackdropClick disableEscapeKeyDown maxWidth={'sm'} open={this.state.open}
				        fullWidth={true} scroll={this.state.scroll} onClose={this.closeModal}
				        aria-labelledby="scroll-dialog-title"
				        PaperComponent={DraggableModal} className={'sendMessage-ticket'}
				>
					
					<DialogTitle style={{color: 'gray'}}>Descargar Archivos de Timbrado</DialogTitle>
					
					<DialogContent>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container spacing={2} className={'h-100'}>
									
									{/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<Typography className={'text-center px-13'} style={{fontWeight: 'bold'}}>
											Datos de timbrado...
										</Typography>
									</Grid>*/}
									
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12} align={'center'}>
										<div className={'w-200-px text-center'}>
												<div className={'borde-punteado-lightgray-1 card-0 text-center cursor-pointer margin-10-R'}  onClick={() => this.exportar(this.props.item.ruta)}>
													<div className={'w-100 text-center padding-10-B padding-10-T'}>
														<span style={{cursor: 'pointer', fontSize: 14}}>
															Archivo XML
														</span>
													</div>
													<div className={'w-100 text-center check-notificacion'}>
														<div className={'w-100 margin-10-B'}>
															<img className={'v-center'} src={icon_email} alt="add" width={80} height={80} style={{opacity: 0.7}}/>
														</div>
													</div>
												</div>
										</div>
											
											</Grid>
									
								</Grid>
							</Grid>
						</Grid>

					</DialogContent>
					
					<DialogActions>
						<Grid container spacing={0}>
							<Grid item xs={12} align={'right'}>
								<Button onClick={() => this.close()} color="primary">
									{"Cerrar"}
								</Button>
							</Grid>
						</Grid>
					</DialogActions>
				</Dialog>
			
			</span>
		);
	}
}

ModalPrevisualizarTimbrado.propTypes = {
	tipo: PropTypes.oneOf([
		"add",
		"view",
		"edit",
	]),
	item: PropTypes.object.isRequired,
	showSnackBars: PropTypes.func.isRequired,
	component: PropTypes.element,
	RefreshList: PropTypes.func.isRequired,
};

export default ModalPrevisualizarTimbrado;
